import { Action } from '@ngrx/store';

export enum ELoaderActions {
  UpdateLoaderVisibility = '[Loader] Hide/Display loader'
}

export class UpdateLoaderVisibility implements Action {
  public readonly type = ELoaderActions.UpdateLoaderVisibility;
  constructor(public payload: number) {}
}

export type LoaderActions = UpdateLoaderVisibility;
